import { APIPersonalAutoApplicationFormVehicle } from 'types/api.types';
import { BinderSectionData } from '../hooks/useBinderSectionData';
import { processValidation, validateFailedObjects } from '../utils/helpers';

export const processAnnualDrivingDistanceData = (
  vehicles: APIPersonalAutoApplicationFormVehicle[],
  remarks: Remark[],
  validation?: Validation,
): BinderSectionData => {
  const processedAnnualDrivingDistanceData = {
    vehicles: vehicles.map((vehicle, index: number) => {
      const annualDistance = vehicle?.estimated_annual_driving_distance || 0;
      const isValid = validateFailedObjects(index, validation);
      const numValue =
        typeof annualDistance === 'string'
          ? parseFloat(annualDistance)
          : annualDistance;

      return {
        index: index + 1,
        name:
          vehicle?.make && vehicle?.model
            ? `${vehicle.make} ${vehicle.model}`
            : `Vehicle ${index + 1}`,
        annualDistance: numValue,
        remarks: remarks.find((r) => r.item_key === `vehicle-${index + 1}`)
          ?.text,
        isValid,
      };
    }),
  };

  const validationData = processValidation(validation);

  return {
    title: 'Low annual driving distance',
    description:
      'Check to confirm that annual driving distance is not underreported.',
    isValid: validationData.isValid,
    message: validationData.message,
    data: processedAnnualDrivingDistanceData,
  };
};
